'use client'

function normalizeDomain(value: string | undefined): string | null {
  if (!value) return null
  const trimmed = value.trim().toLowerCase()
  if (!trimmed) return null

  try {
    const withProtocol =
      trimmed.startsWith('http://') || trimmed.startsWith('https://')
        ? trimmed
        : `https://${trimmed}`
    return new URL(withProtocol).hostname.toLowerCase()
  } catch {
    return trimmed
      .replace(/^https?:\/\//, '')
      .split('/')[0]
      .split(':')[0]
      .toLowerCase()
  }
}

export function isAnalyticsDomainAllowed(): boolean {
  if (typeof window === 'undefined') return false

  const expected = normalizeDomain(process.env.NEXT_PUBLIC_CURRENT_DOMAIN)
  if (!expected) return true

  return window.location.hostname.toLowerCase() === expected
}

export function shouldDisableGoogleAnalyticsAtRuntime(
  gaId: string | undefined,
): boolean {
  if (!gaId) return true
  return !isAnalyticsDomainAllowed()
}
